import { render, staticRenderFns } from "./form.vue?vue&type=template&id=19f55e2e&"
import script from "./form.vue?vue&type=script&lang=ts&"
export * from "./form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f55e2e')) {
      api.createRecord('19f55e2e', component.options)
    } else {
      api.reload('19f55e2e', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=19f55e2e&", function () {
      api.rerender('19f55e2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/microblog/form.vue"
export default component.exports